import styled, { css } from 'styled-components'

import { Colors } from 'common-constants/colors'
import { RouterLink } from 'components/presentational/link'
import { zIndex } from 'components/presentational/zIndex'

export interface BaseArrowsProps {
  $alwaysShow: boolean
}

interface ArrowProps {
  size?: number
  height?: number
}

export const baseArrowsCss = css<BaseArrowsProps>`
  display: flex;
  position: absolute;
  z-index: ${zIndex.base};
  top: 0;
  opacity: 0;

  @media (hover: none) {
    opacity: ${(props) => (props.theme.javaScriptEnabled ? '0' : '1')};
  }

  transition: all 0.2s ease-in-out;
  align-items: center;
  cursor: pointer;

  &:hover {
    svg g circle {
      fill: ${Colors.linkHover};
    }
  }

  &:active {
    svg g circle {
      fill: ${Colors.checkboxActive};
    }
  }

  ${(props) =>
    props.$alwaysShow
      ? ''
      : `
    @media (hover: none) {
      display: ${props.theme.javaScriptEnabled ? 'none' : 'flex'};
    }
  `}
`

/**
 * height - в исключительных случаях когда под блоком есть какой-то контент, пример промо на хитлисте.
 */
export const arrowCss = css<
  { size?: number; height?: number } & BaseArrowsProps
>`
  ${baseArrowsCss};
  box-sizing: border-box;
  width: ${(props) => (props.size ? `${props.size}px` : '30%')};
  height: ${(props) => (props.height ? `${props.height}px` : '100%')};
  -webkit-tap-highlight-color: transparent;

  @media (hover: none) {
    svg {
      display: ${(props) => (props.theme.javaScriptEnabled ? 'none' : 'flex')};
    }
  }
`

export const arrowLeftCss = css`
  ${arrowCss};
  ${(props) => props.theme.left}: 0;
  ${(props) => props.theme.paddingLeft}: 20px;

  justify-content: flex-start;
`

export const arrowRightCss = css`
  ${arrowCss};
  ${(props) => props.theme.right}: 0;
  ${(props) => props.theme.paddingRight}: 20px;

  justify-content: flex-end;
`

export const LeftArrow = styled.div<ArrowProps & BaseArrowsProps>`
  ${arrowLeftCss}
`
export const RightArrow = styled.div<ArrowProps & BaseArrowsProps>`
  ${arrowRightCss}
`

export const LeftArrowHref = styled(RouterLink)`
  ${arrowLeftCss}
`

export const RightArrowHref = styled(RouterLink)`
  ${arrowRightCss};
`
